import React from "react";

export default function App() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-md mx-auto text-center">

        {/* Logo */}
        <div className="flex flex-col items-center mb-6">
          <img src="/icon.svg" alt="ناریجه" className="w-32 h-32 mb-2" />
          <p className="text-sm text-gray-600 mt-1">سامانه هوشمند رزرو غذا</p>
        </div>

        {/* Alert */}
        <div className="bg-white p-3 rounded-xl border mb-6 shadow-sm">
          <p className="text-xs text-gray-700 font-medium">
            <span className="font-bold">اطلاع رسانی جدیدی در دسترس نیست</span>
          </p>
        </div>

        {/* Buttons */}
        <div className="grid gap-4">

          {/* Personnel */}
          <a
            href="https://my.narijeh.co/order"
            className="block bg-white p-4 rounded-xl shadow border hover:bg-gray-100 transition"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-800 mb-1">پنل رزرو غذای پرسنلی</h3>
              <span className="text-xs text-green-600 font-bold">ورود به پنل رزرو </span>
            </div>
          </a>

          {/* Admin */}
          <a
            href="https://panel.narijeh.co/order"
            className="block bg-white p-4 rounded-xl shadow border hover:bg-gray-100 transition"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-800 mb-1">پنل رزرو مدیریتی شرکتی</h3>
              <span className="text-xs text-blue-600 font-bold">ورود به پنل رزرو</span>
            </div>
          </a>

        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-[10px] text-gray-500">
          © طراحی و توسعه راهکار پویش - RPTEAM 2025
        </div>
      </div>
    </div>
  );
}
